import { InstagramAccount, GradientColors } from "@markit/common.types";
import { InitialsPic } from "../../InitialsPic";
import { useMemo } from "react";

type SocialProfilePicProps = {
  account: InstagramAccount | undefined;
  size: number;
  onPress?: () => void;
  forcePointer?: boolean;
  borderStyle?: string;
};

// Same pattern as ProfilePic - real photo when we have one, otherwise a
// random gradient with the account's initials
const SocialProfilePic = (props: SocialProfilePicProps) => {
  const { account, size, onPress, borderStyle, forcePointer } = props;

  const randomGradientColor: string[] = useMemo(
    () =>
      Object.values(GradientColors)[
        Math.floor(Math.random() * Object.values(GradientColors).length)
      ],
    []
  );

  if (account && !!account.profilePicUrl) {
    return (
      <div
        onClick={onPress}
        style={{
          cursor: onPress || forcePointer ? "pointer" : "auto",
          width: size,
          height: size,
          borderRadius: size / 2,
          border: borderStyle,
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <img
          src={account.profilePicUrl}
          alt="SocialProfilePicURL"
          style={{
            display: "block",
            borderRadius: size / 2,
            objectFit: "cover",
            height: "100%",
            width: "100%",
          }}
        />
      </div>
    );
  } else {
    return (
      <div
        onClick={onPress}
        style={{
          cursor: onPress || forcePointer ? "pointer" : "auto",
          width: size,
          height: size,
          borderRadius: size / 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `linear-gradient(to bottom, ${randomGradientColor[0]}, ${randomGradientColor[1]}`,
        }}
      >
        <InitialsPic
          fullName={account?.username}
          size={size / 3}
          pointer={forcePointer}
        />
      </div>
    );
  }
};

export default SocialProfilePic;
